import { render, staticRenderFns } from "./TwAddGoods.vue?vue&type=template&id=4644c14c&"
import script from "./TwAddGoods.vue?vue&type=script&lang=js&"
export * from "./TwAddGoods.vue?vue&type=script&lang=js&"
import style0 from "./TwAddGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports